import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useHistory() {
  return React.useContext(NaviContext).navigation.history;
}
export function History(props) {
  return React.createElement(NaviContext.Consumer, null, function (context) {
    return props.children(context.navigation.history);
  });
}